import {Directive, HostListener, Input, AfterViewInit, Renderer, ElementRef } from "@angular/core";

import {ApplicationConfiguration} from "../../core"
import {PLACEHOLDER} from "../../util/constants/constants";

@Directive({
    selector: '[rxPlaceholder]'
})
export class RxPlaceholderDirective implements AfterViewInit {
    private element: Node;
    private currentFormControlName: string;
    private currentPlaceholderText: string;
    constructor(private renderer: Renderer, private elementRef: ElementRef) { this.element = elementRef.nativeElement as Node }

    @Input('rxPlaceholder') set placeholder(value: string) {
        this.currentPlaceholderText = value;
        this.setPlaceholder(value);
    }

    @Input('formControlName') formControlName:string;

    ngAfterViewInit(): void {
        if (!this.currentPlaceholderText) {
            var placeholderText = ApplicationConfiguration.get(`${PLACEHOLDER}.${this.formControlName}`);
            this.setPlaceholder(placeholderText);
        }
    }
    setPlaceholder(value: string): void {
        this.renderer.setElementAttribute(
            this.element, PLACEHOLDER, value);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@rx/forms/placeholder/rx_placeholder_control_directive.ts